import { twMerge } from 'tailwind-merge';
import { tv } from 'tailwind-variants';

import { clsx, type ClassValue } from '@/libs';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export { tv };
